import hexRgb from 'hex-rgb'

/**
 * 色処理ユーティリティークラス
 */
class ColorUtil {
  /**
   * hexカラーをrgb配列に変換する
   * @param {String} hexColor 色コード(#xxxxxx)
   * @returns {Array.<Number>} rgb配列
   */
  hexToRgb(hexColor) {
    const rgb = hexRgb(hexColor)
    return [rgb.red, rgb.green, rgb.blue]
  }

  /**
   * rgbカラーをhex文字列に変換する
   * @param {Array.<Number>} rgb rgb配列
   * @returns {String} 色コード(#xxxxxx)
   */
  rgbToHex(rgb) {
    const red = ('0' + rgb[0].toString(16)).slice(-2)
    const green = ('0' + rgb[1].toString(16)).slice(-2)
    const blue = ('0' + rgb[2].toString(16)).slice(-2)
    return `#${red}${green}${blue}`
  }

  /**
   * 相対輝度に応じて文字の色を選択する
   * @param {String} hexColor 色コード(#xxxxxx)
   * @returns {string} 文字色(Hex)
   */
  chooseTextColor(hexColor) {
    const relativeLuminance = this.calcRelativeLuminance(hexColor)

    const contrastRatioWhite = 1.05 / (relativeLuminance + 0.05)
    const contrastRatioBlack = (relativeLuminance + 0.05) / 0.05

    return contrastRatioWhite < contrastRatioBlack ? '#000000' : '#ffffff'
  }

  /**
   * 入力カラーコードから相対輝度を求める
   * https://waic.jp/docs/WCAG-TECHS/G17.html
   *
   * @param {String} hexColor 色コード(#xxxxxx)
   * @returns {number} 相対輝度
   */
  calcRelativeLuminance(hexColor) {
    const toRgb = (value) => {
      const i = value / 255
      if (i <= 0.03928) {
        return i / 12.92
      } else {
        return Math.pow((i + 0.055) / 1.055, 2.4)
      }
    }

    const hRgb = hexRgb(hexColor)
    const rgb = {
      r: toRgb(hRgb.red),
      g: toRgb(hRgb.green),
      b: toRgb(hRgb.blue),
    }
    return 0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b
  }
}

export default new ColorUtil()
